"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ILogger_1 = require("./ILogger");
var axios_1 = require("axios");
var BaseLogger = (function () {
    function BaseLogger(name, url, interval, onLogs, perLength) {
        this.isUploading = false;
        this.onLogs = onLogs;
        this.logName = name;
        this.apiUrl = url;
        this.interval = interval;
        this.perLength = perLength;
        this.init();
    }
    BaseLogger.prototype.info = function (data, comment) {
        this.add(ILogger_1.LogLevel.Info, data, comment);
    };
    BaseLogger.prototype.warn = function (data, comment) {
        this.add(ILogger_1.LogLevel.Warn, data, comment);
    };
    BaseLogger.prototype.error = function (data, comment) {
        this.add(ILogger_1.LogLevel.Error, data, comment);
    };
    BaseLogger.prototype.add = function (level, data, comment) { };
    BaseLogger.prototype.getLogByTime = function (from, to, callbackFn) { };
    BaseLogger.prototype.getLogByLen = function (len, callbackFn) { };
    BaseLogger.prototype.keep = function (daysToMaintain) { };
    BaseLogger.prototype.clean = function () { };
    BaseLogger.prototype.cleanByLen = function (len) { };
    BaseLogger.prototype.sendByManual = function () {
        this.onTick();
    };
    BaseLogger.prototype.init = function () {
        this.onTick = this.onTick.bind(this);
        this.initTick();
        this.initDB();
    };
    BaseLogger.prototype.initDB = function () { };
    BaseLogger.prototype.initTick = function () {
        var that = this;
        function logData() {
            that.sendLogs(999999, true);
        }
        setInterval(this.onTick, this.interval);
        window.addEventListener('unload', logData, false);
    };
    BaseLogger.prototype.onTick = function () {
        if (typeof this.apiUrl === 'function') {
            var url = this.apiUrl();
            if (url === '' || url === undefined) {
                return;
            }
            this.apiUrl = url;
        }
        if (!this.isUploading) {
            this.sendLogs(this.perLength);
        }
    };
    BaseLogger.prototype.sendLogs = function (len, isClose) {
        if (isClose === void 0) { isClose = false; }
        try {
            var that_1 = this;
            this.getLogByLen(len, function (logs) {
                var logsLen = logs.length;
                if (logsLen === 0) {
                    console.log('暂无日志');
                    return;
                }
                var logStr = that_1.onLogs(logs);
                if (isClose) {
                    navigator.sendBeacon(that_1.apiUrl, logStr);
                }
                else {
                    that_1.isUploading = true;
                    axios_1.default
                        .post(that_1.apiUrl, logStr, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(function (response) {
                        that_1.isUploading = false;
                        that_1.cleanByLen(logsLen);
                    })
                        .catch(function (error) {
                        that_1.isUploading = false;
                        console.log(error);
                    });
                }
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    return BaseLogger;
}());
exports.BaseLogger = BaseLogger;
//# sourceMappingURL=BaseLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/log/BaseLogger.js
// module id = 9nfM
// module chunks = 0